<template>
	<div class="mb-3 relative">
		<div class="p-5 text-center absolute mt-min4" v-if="isFetching">
			<div class="is-loading large"></div>
		</div>
		<div class="ml-3" v-if="filteredAnnouncements.length > 0">
			<div  class="text-grey mb-1">There is upcoming events in the near future:</div>
			<div v-for="item in filteredAnnouncements" :key="item.id">
				<div  class="mb-1 pl-3 relative list-announce">
					<div class="absolute left-list-announce"></div>
					<li class="pt-1">{{convertTimestamp(item.start_date)}} - {{convertTimestamp(item.end_date)}}, {{item.title}}</li>
				</div>
			</div>
		</div>
		<div class="ml-3" v-if="filteredMaintenences.length > 0">
			<div class="text-grey mb-1">There is upcoming maintenance in the near future:</div>
			<div v-for="item in filteredMaintenences" :key="item.id">
				<div  class="mb-1 pl-3 relative list-announce">
					<div class="absolute left-list-announce"></div>
					<li class="pt-1">{{convertTimestamp(item.start_date)}} - {{convertTimestamp(item.end_date)}}, {{item.title}}</li>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import announcementsApi from '@/api/announcements';
import { getAxiosErrorMessage, delay } from '@/lib/helper';

export default {
	name: 'AnnouncementNotification',
	data() {
		return {
			isFetching: false,
			items: [],
		};
	},
	props: {
	},
	methods: {
		fetch() {
			this.items = [];
			this.isFetching = true;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
			};
			if (this.isSuperAdmin) params.is_published = 1;
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			announcementsApi.getList(params, callback, errorCallback);
		},
		convertTimestamp(time) {
			const date = new Date(time);
			return dayjs(date).format('MMMM DD, YYYY HH:mm');
		},
	},
	computed: {
		...mapGetters({
			isSuperAdmin: 'isSuperAdmin',
		}),
		filteredAnnouncements() {
			const filter = item => (item.type === 'announcement');
			return this.items.filter(filter);
		},
		filteredMaintenences() {
			const filter = item => (item.type === 'maintenance');
			return this.items.filter(filter);
		},
	},
	created() {
		delay(() => {
			this.isFetching = true;
			this.fetch();
		}, 500);
	},
	destroyed() {
	},
};
</script>
